"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _index = require("../../../index");

var _reactJss = _interopRequireDefault(require("react-jss"));

var _incdecinput_styles = _interopRequireDefault(require("./incdecinput_styles"));

var _incdecinput_definition = _interopRequireDefault(require("./incdecinput_definition"));

var _definecomponent = require("../../../../utils/definecomponent");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
// material
// styles
// definition

/* ========== ~~~~~~~~~~ EXPORT : COPY FIELD ~~~~~~~~~~ ========== */


var IncDecField = (0, _reactJss.default)(_incdecinput_styles.default)(function (props) {
  var classes = props.classes,
      name = props.name,
      ctaPosition = props.ctaPosition,
      defaultValue = props.defaultValue,
      minValue = props.minValue,
      maxValue = props.maxValue,
      handleIncToggle = props.handleIncToggle,
      handleDecToggle = props.handleDecToggle,
      disabled = props.disabled;

  var handleButtonClick = function handleButtonClick(e, dir) {
    if (dir === 'plus') {
      if (defaultValue >= maxValue) {
        return;
      }

      if (handleIncToggle) {
        handleIncToggle(defaultValue + 1);
      }
    } else {
      if (defaultValue <= minValue) {
        return;
      }

      if (handleDecToggle) {
        handleDecToggle(defaultValue - 1);
      }
    }
  };

  var minusDisabled = defaultValue <= minValue;
  var plusDisabled = defaultValue >= maxValue;
  return _react.default.createElement("div", {
    className: "incdecfield ".concat(classes.incdecfield, " incdecfield-").concat(name, " fieldHeight-inline ctaPosition-").concat(ctaPosition, " disabled-").concat(disabled)
  }, _react.default.createElement(_index.CTAs, null, _react.default.createElement(_index.Button, {
    name: 'minusCTA',
    type: 'action',
    icon: 'minus',
    operation: 'link',
    handleClick: function handleClick(e) {
      return handleButtonClick(e, 'minus');
    },
    disabled: minusDisabled
  })), _react.default.createElement(_index.TextField, {
    type: 'text',
    defaultValue: defaultValue,
    value: defaultValue,
    readOnly: true,
    name: name
  }), _react.default.createElement(_index.CTAs, null, _react.default.createElement(_index.Button, {
    name: 'positiveCTA',
    type: 'action',
    icon: 'plus',
    operation: 'link',
    handleClick: function handleClick(e) {
      return handleButtonClick(e, 'plus');
    },
    disabled: plusDisabled
  })));
});
/* ========== ~~~~~~~~~~ DEFINE COMPONENT ~~~~~~~~~~ ========== */

(0, _definecomponent.defineComponent)(IncDecField, _incdecinput_definition.default, false);
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

var _default = IncDecField;
exports.default = _default;